class UspSlider {
	constructor(config = {}) {
		this.config = Object.assign({
			scope: '.usp_slider',
			debounceDelay: 50,
			modifiers: { mobile: 1.25, desktop: 1.2 },
			breakpoint: 992,
		}, config);

		this.timeouts = new Map();
		this.scopes = document.querySelectorAll(this.config.scope);

		if (this.scopes.length > 0) {
			this.init();
		}
	}

	init() {
		this.scopes.forEach((scope, index) => {
			new ResizeObserver(() => this.setMinHeight(scope, index)).observe(scope);
		});
	}

	setMinHeight(scope, index) {
		const id = `usp-slider-${index}`;
		const existing = this.timeouts.get(id);
		if (existing) clearTimeout(existing);

		this.timeouts.set(id, setTimeout(() => {
			const slides = scope.querySelectorAll('.swiper-slide');
			let height = 0;

			slides.forEach(slide => {
				if (slide.offsetHeight > height) height = slide.offsetHeight;
			});

			const modifier = window.outerWidth >= this.config.breakpoint
				? this.config.modifiers.desktop
				: this.config.modifiers.mobile;

			const minHeight = Math.round(height * modifier);
			scope.querySelector('.swiper-outer').style.setProperty('--height', `${minHeight}px`);

			this.timeouts.delete(id);
		}, this.config.debounceDelay));
	}
}

export default new UspSlider();
